import { render, staticRenderFns } from "./MultilineTextQuestion.vue?vue&type=template&id=c03b5f66&scoped=true&"
import script from "./MultilineTextQuestion.vue?vue&type=script&lang=js&"
export * from "./MultilineTextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultilineTextQuestion.vue?vue&type=style&index=0&id=c03b5f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b5f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
